import React from "react";
import isEmpty from "../../../core/helpers/isEmpty";
import localize from "../../../core/utils/translation-files";
import RenderSvg from "../icons/RenderSvg";
const PageDescription = ({ title, description, isLoading = false, customDescriptionStyle }) => {
    var _a;
    return (React.createElement("div", { className: "pageDescription" },
        React.createElement(RenderSvg, { icon: "Info", style: Object.assign({ padding: "10px 15px", background: "#efcefe", borderRight: "1px solid #d08bc9" }, (customDescriptionStyle || {})) }),
        React.createElement("span", { className: "descriptionArea" },
            React.createElement("strong", null, (_a = localize(title)) !== null && _a !== void 0 ? _a : "",
                " "),
            isEmpty(description) && !isLoading ? "No description" : description)));
};
export default PageDescription;
